import React from "react";
import classNames from "classnames";

export default function Container({
    children,
    className = "",
}) {

    let classes = typeof className === "string" ? className.split(" ").reduce((acc, item) => {
        acc[item] = true
        return acc
    }, {}) : className;

    const Classes = classNames({
        "container w-full mx-auto px-6 md:px-10 xl:px-28 max-w-[1200px]": true,
        ...classes
    })

    return (
        <div className={Classes}>
            {children}
        </div>
    )
}